function absPos(source) {
  let root = this.__execs__.canvas.node();
  const posLocal = this.__execs__.mark;
  let x= 0, y = 0;
  while(root !== source) {
    let pos = posLocal.get(source);
    if(pos) {
      x += pos.x;
      y += pos.y;
      source = source.parentNode;
    } else {
      break;
    }
  }
  return {x,y};
}

export default absPos;


// WEBPACK FOOTER //
// ./layouts/default/absPos.js